// import React from 'react'
// import { useLocation } from 'react-router-dom'
// import ScreenLayout from 'components/ScreenLayout'
// import CheckOutConfirmForm from
//   'screens/CheckOutConfirmScreen/components/CheckOutConfirmForm'

// const SignUpConfirmScreen: React.FC = () => {
//   const location = useLocation<{ originalEmail?: string }>()

//   const originalEmail = location.state?.originalEmail || ''

//   return (
//     <ScreenLayout disableModal>
//       <CheckOutConfirmForm
//         resetToken=""
//         originalEmail={originalEmail}
//         reservationCode=""
//       />
//     </ScreenLayout>
//   )
// }

// export default SignUpConfirmScreen


import React from 'react'
import { useLocation } from 'react-router-dom'
import ScreenLayout from 'components/ScreenLayout'
import CheckOutConfirmForm from
  'screens/CheckOutConfirmScreen/components/CheckOutConfirmForm'

type LocationState = {
  originalEmail?: string
  resetToken?: string
}

const SignUpConfirmScreen: React.FC = () => {
  const location = useLocation<LocationState>()

  const originalEmail = location.state?.originalEmail || ''
  const resetToken = location.state?.resetToken || ''

  return (
    <ScreenLayout disableModal>
      <CheckOutConfirmForm
        resetToken={resetToken}
        originalEmail={originalEmail}
        reservationCode=""
      />
    </ScreenLayout>
  )
}

export default SignUpConfirmScreen